import { Autocomplete, Button, Pane, SelectField, Text, TextareaField, TextInputField } from 'evergreen-ui';
import { Formik } from 'formik';
import { Component } from 'react';
import Api from '../../../util/Api';

const STATUS_OPTIONS = [
    { value: 'pending', label: 'In asteptare' },
    { value: 'confirmed', label: 'Confirmat' },
    { value: 'checked_in', label: 'Check-in' },
    { value: 'cancelled', label: 'Anulat' },
    { value: 'no_show', label: 'Absent' }
];

const PAYMENT_STATUS_OPTIONS = [
    { value: 'unpaid', label: 'Neplatit' },
    { value: 'paid', label: 'Platit' },
    { value: 'refunded', label: 'Rambursat' }
];

export default class EventReservationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventSearchResults: [],
            selectedEventData: null
        };
        this.searchTimeout = null;
    }

    componentDidMount() {
        // Load initial event if editing - use event from reservation object
        if (this.props.initialValues.event) {
            this.setState({ selectedEventData: this.props.initialValues.event });
        } else if (this.props.initialValues.eventId && this.props.events.length > 0) {
            const event = this.props.events.find(e => e.id === this.props.initialValues.eventId);
            if (event) {
                this.setState({ selectedEventData: event });
            }
        }
    }

    componentDidUpdate(prevProps) {
        // Update selected event if reservation data changes
        if (this.props.initialValues.event && !prevProps.initialValues.event) {
            this.setState({ selectedEventData: this.props.initialValues.event });
        }
    }

    handleEventSearch = async (query) => {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        if (!query || query.length < 2) {
            this.setState({ eventSearchResults: [] });
            return;
        }

        // Clear previous results before searching
        this.setState({ eventSearchResults: [] });

        this.searchTimeout = setTimeout(async () => {
            try {
                const response = await Api.get('/events', {}, { 
                    _start: 0, 
                    _end: 20,
                    q: query
                });
                
                if (response.success) {
                    this.setState({ eventSearchResults: response.data || [] });
                }
            } catch (error) {
                console.error('Error searching events:', error);
                this.setState({ eventSearchResults: [] });
            }
        }, 300);
    }

    render() {
        const { events = [], paymentTypes = [] } = this.props;
        const { eventSearchResults, selectedEventData } = this.state;

        return (
            <Formik
                initialValues={this.props.initialValues}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={(values) => {
                    this.props.onSave(values);
                }}
            >
                {({ errors, handleChange, handleBlur, handleSubmit, setFieldValue, values }) => {
                    errors = Object.assign({}, this.props.errors, errors);
                    
                    const displayEvent = selectedEventData || events.find(e => e.id === values.eventId);
                    const searchResults = eventSearchResults.length > 0 ? eventSearchResults : (displayEvent ? [displayEvent] : []);

                    return <form>
                        <Pane marginBottom={16}>
                            <Text display="block" marginBottom={4} fontWeight={500}>
                                Eveniment *
                            </Text>
                            <Autocomplete
                                title="Cauta eveniment"
                                onChange={(selectedItem) => {
                                    if (selectedItem) {
                                        setFieldValue('eventId', selectedItem.id);
                                        setFieldValue('amount', selectedItem.price || 0);
                                        this.setState({ selectedEventData: selectedItem });
                                    }
                                }}
                                items={searchResults}
                                itemToString={(item) => item ? `${item.title} - ${new Date(item.start).toLocaleDateString('ro-RO')} (${item.location})` : ''}
                                itemSize={40}
                                popoverMaxHeight={400}
                                isFilterDisabled={true}
                            >
                                {(props) => {
                                    const { getInputProps, getRef, inputValue, openMenu } = props;
                                    const inputProps = getInputProps({
                                        ref: getRef,
                                        placeholder: 'Cauta eveniment...',
                                        onFocus: () => {
                                            openMenu();
                                            if (displayEvent && !inputValue) {
                                                this.handleEventSearch(displayEvent.title);
                                            }
                                        },
                                    });
                                    
                                    return (
                                        <TextInputField
                                            label=""
                                            {...inputProps}
                                            onChange={(e) => {
                                                inputProps.onChange(e);
                                                this.handleEventSearch(e.target.value);
                                            }}
                                            validationMessage={errors.eventId}
                                        />
                                    );
                                }}
                            </Autocomplete>
                            {displayEvent && (
                                <Text size={300} color="muted" display="block" marginTop={4}>
                                    Selectat: {displayEvent.title} - {new Date(displayEvent.start).toLocaleDateString('ro-RO')}
                                </Text>
                            )}
                        </Pane>

                        <TextInputField
                            required
                            label="Nume complet"
                            name="name"
                            value={values.name || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            validationMessage={errors.name}
                        />

                        <TextInputField
                            required
                            label="Email"
                            name="email"
                            type="email"
                            value={values.email || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            validationMessage={errors.email}
                        />

                        <TextInputField
                            required
                            label="Telefon"
                            name="phone"
                            value={values.phone || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            validationMessage={errors.phone}
                        />

                        <Pane marginBottom={16}>
                            <Text display="block" marginBottom={8} fontWeight={500}>
                                Metoda de plata
                            </Text>
                            {paymentTypes.length > 0 ? (
                                <Pane display="flex" gap={8} flexWrap="wrap">
                                    {paymentTypes.map(pt => (
                                        <Button
                                            key={pt.id}
                                            type="button"
                                            appearance={values.paymentTypeId === pt.id ? 'primary' : 'default'}
                                            onClick={() => setFieldValue('paymentTypeId', pt.id)}
                                        >
                                            {pt.name}
                                        </Button>
                                    ))}
                                </Pane>
                            ) : (
                                <Text color="muted">Se incarca metodele de plata...</Text>
                            )}
                        </Pane>

                        <TextareaField
                            label="Note"
                            name="notes"
                            value={values.notes || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />

                        <Pane borderTop="default" marginTop={16} paddingTop={16}>
                            <Button type="submit" appearance="primary" onClick={handleSubmit}>
                                Salveaza
                            </Button>
                        </Pane>
                    </form>
                }}
            </Formik>
        );
    }
}
